export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          关于我们
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          了解每日大赛入口的定位与使命
        </p>

        <div className="rounded-2xl border border-background-200/80 bg-background-50 p-8 md:p-10">
          <div className="flex flex-col lg:flex-row gap-8 items-start">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 rounded-2xl bg-primary-100 flex items-center justify-center">
                <i className="ri-trophy-line text-3xl text-primary-600"></i>
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground-900 font-heading mb-4">
                每日大赛入口 — 你的每日大赛作品介绍与类型大全
              </h3>
              <div className="space-y-3 text-sm text-foreground-600 leading-relaxed">
                <p>
                  每日大赛入口是一个专注于各类大赛视频内容介绍与整理的在线平台。我们每日追踪各大视频平台和社区的热门大赛动态，
                  为用户提供全面、及时的每日大赛作品介绍、每日大赛类型分类和每日大赛列表，打造一站式的每日大全浏览体验。
                </p>
                <p>
                  平台覆盖舞蹈、音乐、创意设计、编程竞赛、短视频创作、摄影、美食、cosplay等30多种大赛类型，
                  以作品介绍、排行推荐和专题索引的形式帮助用户发现优质大赛内容，无论是寻找创作灵感还是欣赏优秀作品，
                  每日大赛入口都是理想的在线平台。
                </p>
                <p>
                  我们坚持<strong>每日更新、内容丰富、分类清晰</strong>的原则，
                  持续扩展每日大赛列表覆盖范围，让每日大赛入口成为大赛爱好者的首选每日大赛官网。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}